import './styles/tailwind.css';

import {
  CatalogContext,
  CatalogContextProvider,
  useCatalogContext,
} from './lib/Contexts/CatalogContext';
// biome-ignore lint/performance/noBarrelFile: <explanation>
export * from './lib/Hooks/useCiCSearch';
import { useProductLink } from './lib/Hooks/useProductLink';
import { FilterPanel } from './lib/Modules/Filters/FilterPanel';
import { Paginator } from './lib/Modules/Paginations/Paginator';
import { SRPPaginator } from './lib/Modules/Paginations/SRPPaginator';
import { MarkFavourite } from './lib/Modules/ProductCard/MarkFavourite';
import { MissingImage } from './lib/Modules/ProductCard/MissingImage';
import { ProductCard } from './lib/Modules/ProductCard/ProductCard';
import { ProductLink } from './lib/Modules/ProductCard/ProductLink';
import { ProductTags } from './lib/Modules/ProductCard/ProductTags';
import { Samples } from './lib/Modules/ProductCard/Samples';
import { BannerZone } from './lib/Modules/ProductDetails/BannerZone';
import { DownloadLink } from './lib/Modules/ProductDetails/DownloadLink';
import { ProductDetails } from './lib/Modules/ProductDetails/ProductDetails';
import { ProductDetailsClientSide } from './lib/Modules/ProductDetails/ProductDetailsClientSide';
import { ProductSpec } from './lib/Modules/ProductDetails/ProductSpec';
import { Section } from './lib/Modules/ProductDetails/Section';
import { SwatchZoom } from './lib/Modules/ProductDetails/SwatchZoom';
import { VizLoaderBrokerInit } from './lib/Modules/ProductDetails/VizLoaderBrokerInit';
import { WebVisualizer } from './lib/Modules/ProductDetails/WebVisualizer';
import { ProductResults } from './lib/Modules/ProductResults/ProductResults';
import { ProductResultsBanner } from './lib/Modules/ProductResults/ProductResultsBanner';
import {
  FavouritesCount,
  HeartIcon,
} from './lib/Modules/ProductToolbar/FavouritesCount';
import { ShopifyScript } from './lib/ShopifyScript';
import { useShopifyScript } from './lib/useShopifyScript';

import { PDP, SRP } from './lib/catalog-ui';

export {
  SRP,
  PDP,
  Paginator,
  CatalogContext,
  CatalogContextProvider,
  useCatalogContext,
  useProductLink,
  FilterPanel,
  ProductResults,
  ProductResultsBanner,
  ProductCard,
  MissingImage,
  ProductLink,
  ProductTags,
  Samples,
  DownloadLink,
  ProductDetails,
  ProductDetailsClientSide,
  SwatchZoom,
  WebVisualizer,
  VizLoaderBrokerInit,
  BannerZone,
  FavouritesCount,
  HeartIcon,
  ProductSpec,
  Section,
  MarkFavourite,
  SRPPaginator,
  ShopifyScript,
  useShopifyScript,
};
